import { render, staticRenderFns } from "./grid-col-offset-editor.vue?vue&type=template&id=584d0090&scoped=true"
import script from "./grid-col-offset-editor.vue?vue&type=script&lang=js"
export * from "./grid-col-offset-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d0090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584d0090')) {
      api.createRecord('584d0090', component.options)
    } else {
      api.reload('584d0090', component.options)
    }
    module.hot.accept("./grid-col-offset-editor.vue?vue&type=template&id=584d0090&scoped=true", function () {
      api.rerender('584d0090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/container-grid-col/grid-col-offset-editor.vue"
export default component.exports